import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import LdsTile from "../../components/LdsTile";
import References from "../../components/References";
import F18Mol from "../../assets/module-1/f18mol.svg";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.1.1 Amyvid: Mechanism of Action
            </h1>
            <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5">
            <LdsImage
              src={F18Mol}
              alt="Chemical structure of a compound showing two benzene rings, nitrogen atoms, and a fluorine-18 isotope attached at the end."
              style={{ maxWidth: "700px" }}
              className="mb-4"
            />
            <LdsTile className="orange-border-tile mt-3 mb-3">
              <p>
                Amyvid is labeled with the F 18 isotope that can be made in PET
                radiopharmaceutical manufacturing facilities and delivered
                through regional nuclear radiopharmacies<sup>1</sup>
              </p>
            </LdsTile>
            <LdsTile className="orange-border-tile mt-3 mb-3">
              <p>
                Amyvid is a radioactive diagnostic agent that binds to amyloid
                plaques, and the F 18 isotope produces a positron signal that is
                detected by a PET scanner<sup>1,2</sup>
              </p>
            </LdsTile>
            <LdsTile className="orange-border-tile mt-3 mb-3">
              <p>
                Binding of Amyvid to amyloid plaques is selective<sup>1</sup>
              </p>
            </LdsTile>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-0-4", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-1-2", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Choi SR, Golding G, Zhuang Z, et al. <em>J Nucl Med.</em>{" "}
                2009;50(11):1887-1894.
              </li>
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_1_1;
